import { NAVIGATION_ENVIRONMENT } from 'config';
import productionLinks from '@grupa-pracuj/business-variables/dist/production';
import betaLinks from '@grupa-pracuj/business-variables/dist/beta';


export const links = NAVIGATION_ENVIRONMENT === 'beta' ? betaLinks : productionLinks;

export default { links };
